import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=39d7c46f&scoped=true&"
import script from "./addModal.vue?vue&type=script&lang=ts&"
export * from "./addModal.vue?vue&type=script&lang=ts&"
import style0 from "./addModal.vue?vue&type=style&index=0&id=39d7c46f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d7c46f",
  null
  
)

export default component.exports